var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNav8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_3110_7787)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.30664 15.3808C4.64501 15.8977 5.04379 16.3762 5.49667 16.8055C6.61887 17.8691 8.02523 18.5848 9.54563 18.8659C11.066 19.1469 12.6353 18.9814 14.0636 18.3893C15.4919 17.7972 16.718 16.8039 17.5936 15.5296C18.4692 14.2552 18.9567 12.7544 18.9972 11.2088C19.0378 9.66317 18.6295 8.13892 17.8219 6.82045C17.0143 5.50198 15.8419 4.44579 14.4466 3.77967C13.5023 3.32886 12.4832 3.06978 11.4479 3.01172L12.0031 5.08362C12.5482 5.17605 13.0808 5.34387 13.5849 5.58455C14.6314 6.08414 15.5107 6.87628 16.1164 7.86513C16.7221 8.85398 17.0283 9.99717 16.9979 11.1564C16.9675 12.3156 16.6019 13.4412 15.9452 14.397C15.2885 15.3527 14.3689 16.0977 13.2977 16.5418C12.2265 16.9859 11.0495 17.11 9.90922 16.8992C8.76892 16.6884 7.71415 16.1516 6.8725 15.3539C6.69677 15.1874 6.53189 15.0109 6.37854 14.8257L4.30664 15.3808Z",
    fill: "#9B9B9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.91239 3.06647C5.68924 2.47037 6.54796 1.99272 7.46042 1.64739C7.87978 1.48868 8.08946 1.40932 8.28694 1.51053C8.48442 1.61174 8.54649 1.84338 8.67063 2.30667L10.7412 10.0341C10.8632 10.4894 10.9242 10.7171 10.8206 10.8964C10.7171 11.0758 10.4894 11.1368 10.0341 11.2588L2.30667 13.3294C1.84338 13.4535 1.61174 13.5156 1.42535 13.3952C1.23896 13.2747 1.20284 13.0535 1.13061 12.6109C0.973443 11.6481 0.95774 10.6656 1.08555 9.69474C1.25696 8.39275 1.68314 7.13728 2.33975 6C2.99636 4.86272 3.87054 3.8659 4.91239 3.06647Z",
    stroke: "#9B9B9B",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_3110_7787",
    x: 0,
    y: 0.464844,
    width: 19.3333,
    height: 18.8685,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.333328,
    dy: 0.333328
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.666656
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.19534 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_3110_7787"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNav8);
export default __webpack_public_path__ + "static/media/nav8.888d5d8d67eeb8766da9957a86ae913b.svg";
export { ForwardRef as ReactComponent };